import React from 'react'
import RewardsIcon from "../../assets/rewards-icon.png"
import { Link } from 'react-router-dom'

export default function Deposit() {
    return (
        <div>
            <div className='rewards_section'>
                <div className='container'>
                    <div className='rewards_heading'>
                        <img src={RewardsIcon} />
                        <p>Book Now & Earn Rewards</p>
                    </div>
                </div>
            </div>

            <div className='container'>
                <div className='wallet_btn_grp'>
                    <Link to='/deposit-crypto'><button className='Crypto'>Crypto</button></Link>
                    <Link to='/deposit-fiat'> <button className='Bank'>Bank</button></Link>
                </div>
            </div>
        </div>
    )
}
